import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../Components/Sidebar';
import AdminSidebar from '../Components/AdminSidebar';
import Home from '../Components/Home1';
import Chat from '../Components/ChatRoom';
import Chats from '../Components/Chats';
import Clientchat from '../Components/Clientchat';
import Transliterate from '../Components/Translate';
import Survey from '../Components/Survey';
import Order from '../Components/Order';
//import Profile from '../Components/Profile';
import ProfileV2 from '../Components/ProfileV2';
import Cart from '../Components/Cart';
import AdminDashboard from '../Components/AdminDashboard';
import ProductManagement from '../Components/ProductManagement';
import OrderManagement from '../Components/OrderManagement';
import UserManagement from '../Components/UserManagement';
import AdminChat from '../Components/AdminChat';
import AdminHennaBookings from '../Components/AdminHennaBookings';
import AdminHennaManagement from '../Components/AdminHennaManagement';
import HennaBooking from '../Components/hennabooking';
import { BASE_URL } from '../config/api';

const Dashboard = () => {
  const [selectedContent, setSelectedContent] = useState('Home');
  const [userRole, setUserRole] = useState('user');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const sessionId = localStorage.getItem('sessionId');
        const storedLoginData = localStorage.getItem('loginData');

        let parsedLoginData = null;
        if (storedLoginData) {
          try {
            parsedLoginData = JSON.parse(storedLoginData);
          } catch (parseError) {
            console.error('Invalid loginData in localStorage:', parseError);
          }
        }

        if (!sessionId) {
          if (parsedLoginData) {
            const role = parsedLoginData?.role || 'user';
            const normalizedRole = role === 'admin3' ? 'admin' : role;
            setUserRole(normalizedRole);
            if (normalizedRole === 'admin' && selectedContent === 'Home') {
              setSelectedContent('AdminDashboard');
            }
            return;
          }

          navigate('/Login');
          return;
        }

        const formattedBaseUrl = BASE_URL.replace(/\/+$/, '') + '/';
        const profileLookupId = /^\d+$/.test(sessionId || '') ? sessionId : parsedLoginData?.id;

        if (!profileLookupId) {
          if (parsedLoginData) {
            const role = parsedLoginData?.role || 'user';
            const normalizedRole = role === 'admin3' ? 'admin' : role;
            setUserRole(normalizedRole);
            if (normalizedRole === 'admin' && selectedContent === 'Home') {
              setSelectedContent('AdminDashboard');
            }
            return;
          }

          navigate('/Login');
          return;
        }

        const response = await fetch(
          `${formattedBaseUrl}auth/user_profile`,
          { headers: { 'session-id': String(profileLookupId) } }
        );

        if (response.ok) {
          const data = await response.json();
          const role = data.user.role || 'user';
          const normalizedRole = role === 'admin3' ? 'admin' : role;
          setUserRole(normalizedRole);

          if (normalizedRole === 'admin' && selectedContent === 'Home') {
            setSelectedContent('AdminDashboard');
          }
        } else {
          if (parsedLoginData) {
            const role = parsedLoginData?.role || 'user';
            const normalizedRole = role === 'admin3' ? 'admin' : role;
            setUserRole(normalizedRole);
            if (normalizedRole === 'admin' && selectedContent === 'Home') {
              setSelectedContent('AdminDashboard');
            }
          } else {
            navigate('/Login');
          }
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        const storedLoginData = localStorage.getItem('loginData');
        if (storedLoginData) {
          try {
            const parsedLoginData = JSON.parse(storedLoginData);
            const role = parsedLoginData?.role || 'user';
            const normalizedRole = role === 'admin3' ? 'admin' : role;
            setUserRole(normalizedRole);
            if (normalizedRole === 'admin' && selectedContent === 'Home') {
              setSelectedContent('AdminDashboard');
            }
          } catch (_parseError) {
            navigate('/Login');
          }
        } else {
          navigate('/Login');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [navigate, selectedContent]);

  useEffect(() => {
    if (location.pathname === '/Checkout') {
      setSelectedContent('Home');
    } else if (location.pathname === '/Cart') {
      setSelectedContent('Cart');
    }
  }, [location.pathname]);

  if (loading) return <div>.</div>;

  const renderContent = () => {
    if (userRole === 'admin') {
      switch (selectedContent) {
        case 'AdminDashboard':
          return <AdminDashboard />;
        case 'ProductManagement':
          return <ProductManagement />;
        case 'OrderManagement':
          return <OrderManagement />;
        case 'UserManagement':
          return <UserManagement />;
        case 'HennaBookingsAdmin':
          return <AdminHennaBookings />;
        case 'HennaManagement':
          return <AdminHennaManagement />;
        case 'AdminChat':
          return <AdminChat />;
        default:
          return <AdminDashboard />;
      }
    } else {
      switch (selectedContent) {
        case 'Home':
          return <Home />;
        case 'ChatRoom':
          return <Chat />;
        case 'Chats':
          return <Chats />;
        case 'ClientChats':
          return <Clientchat />;
        case 'Order':
          return <Order />;
        case 'Transliterate':
          return <Transliterate />;
        case 'Survey':
          return <Survey />;
       /* case 'Profile':
          return <Profile />; */
        case 'ProfileV2':
          return <ProfileV2 />;
        case 'Cart':
          return <Cart />;
        case 'HennaBooking':
          return <HennaBooking />;
        default:
          return <Home />;
      }
    }
  };

  return (
    <DashboardContainer>
      {userRole === 'admin' ? (
        <AdminSidebar onSelect={setSelectedContent} />
      ) : (
        <Sidebar onSelect={setSelectedContent} />
      )}
      <Content>{renderContent()}</Content>
    </DashboardContainer>
  );
};

export default Dashboard;

const DashboardContainer = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
`;

const Content = styled.div`
  flex-grow: 1;
  padding: 20px;
  height: 100vh;
  overflow-y: auto;
  min-width: 0;
`;
